import Controller from '@ember/controller';

export default class AvailablePlansController extends Controller {}

declare module '@ember/controller' {
  interface Registry {
    'billing.available-plans': AvailablePlansController;
  }
}
